import { prefixLanguage } from '@utils/urls'

export const redirectLinks = {
  parent: prefixLanguage('/profile/notification/list/'),
  company: prefixLanguage('/profile/notification/list/'),
  child: prefixLanguage('/profile/notification/list/'),
  employee: prefixLanguage('/profile/notification/list/'),
  teacher: prefixLanguage('/profile/dashboard/list/teacher/'),
  manager: prefixLanguage('/profile/orders/list/'),
}
